module.exports = __webpack_public_path__ + "img/icon-music.fe030902.svg";